import React, { useState, useRef, useEffect } from "react";
import { Download, X } from "lucide-react";

function ModalExcel({
    openModal,
    loading,
    handleCloseModal,
    handleDescargarExcel,
    dataExcel
}) {

    //ya hay la url del excel solo falta descar
    const [dataExcelState, setDataExcelState] = useState(null);






    return (
        <>
            {openModal && (
                <div
                    // className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/50 backdrop-blur-sm p-4"
                    className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/50 p-4"
                    onClick={(e) => e.target === e.currentTarget && handleCloseModal()}
                >
                    <div className="w-full max-w-md overflow-hidden rounded-2xl bg-white shadow-2xl">
                        {/* Header */}
                        <div className="flex items-center justify-between border-b border-gray-100 px-6 py-4">
                            <h2 className="text-base font-bold text-gray-800">
                                Descargar Excel de Facturas de Obsequios
                            </h2>
                            <button
                                type="button"
                                aria-label="cerrar"
                                onClick={handleCloseModal}
                                className="rounded-lg p-1.5 text-gray-400 transition-colors hover:bg-gray-100 hover:text-gray-600"
                            >
                                <X size={20} />
                            </button>
                        </div>

                        {/* Contenido del modal */}
                        <div className="px-6 py-4">
                            <p className="text-sm text-gray-700 mb-2">
                                Puedes descargar el Excel de facturas de obsequios haciendo clic en el botón de abajo.
                            </p>

                            <p className="text-sm text-gray-500">
                                El archivo se generará con la información actualizada de las facturas de obsequios.
                            </p>
                        </div>

                        {/* Footer */}
                        {dataExcel === null && (
                            <div className="border-t border-gray-100 px-6 py-4">
                                <button
                                    type="button"
                                    onClick={handleDescargarExcel}
                                    disabled={loading}
                                    className="flex w-full items-center justify-center gap-2 rounded-lg bg-[#104063] py-2.5 font-semibold text-white transition-colors hover:bg-[#0d3553] disabled:cursor-not-allowed disabled:opacity-70"
                                >
                                    {loading ? (
                                        <>
                                            <span className="h-4 w-4 animate-spin rounded-full border-2 border-white border-t-transparent" />
                                            Cargando...
                                        </>
                                    ) : (
                                        <>
                                            <Download size={16} />
                                            Generar Excel
                                        </>
                                    )}
                                </button>
                            </div>
                        )}
                        {dataExcel !== null && (
                            <div className="border-t border-gray-100 px-6 py-4">
                                <a
                                    href={dataExcel}
                                    download="facturas_obsequios.xlsx"
                                    className="flex w-full items-center justify-center gap-2 rounded-lg bg-green-600 py-2.5 font-semibold text-white transition-colors hover:bg-green-700"
                                >
                                    <Download size={16} />
                                    Descargar Excel
                                </a>
                            </div>
                        )}
                    </div>
                </div>
            )}


        </>
    );
}

export default ModalExcel;
